import PureSelect from './pureselect/PureSelect'
import PureOption from './pureselect/PureOption'


const coms = [PureSelect, PureOption]

const install = function(Vue) {
    coms.forEach((com) => {
        Vue.component(com.name, com)
    })
}

export default install